import React from "react";
import { useQuery } from "react-query";
import { getProgramInfo } from "@website-builder/services";
import { PricingWR } from "@website-builder/ui/shared/components";

const TuitionWR = ({
	label,
	headline,
	description,
	shortname,
	programName,
	getAccordionItems,
}) => {
	const { data = {} } = useQuery(
		["paymentPlanDetails", programName],
		getProgramInfo(shortname, programName),
	);

	const { content: { payment_plans = [] } = {} } = data;
	const shouldDisplayTuition =
		Array.isArray(payment_plans) && payment_plans.length;
	const pricingOptions = getAccordionItems(payment_plans);
	return (
		<>
			{shouldDisplayTuition ? (
				<PricingWR
					label={label}
					headline={headline}
					description={description}
					pricingOptions={pricingOptions}
				/>
			) : null}
		</>
	);
};

export default TuitionWR;
